import traceUFOPress from '@atlaskit/react-ufo/trace-press';
import type { Query } from '@atlassian/react-resource-router';
import { usePreviousWithInitial } from '@atlassian/jira-platform-react-hooks-use-previous/src/common/utils/index.tsx';
import { isFilterId } from '@atlassian/jira-issue-navigator-actions-common/src/utils/filters/index.tsx';
import { isFilterKey } from '@atlassian/jira-spa-apps-project-issue-navigator-utils/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const useFilterChangeInteraction = ({ filter }: Query) => {
	const prevFilter = usePreviousWithInitial(filter);
	if (
		prevFilter !== filter &&
		filter != null &&
		(isFilterId(filter) || isFilterKey(filter)) &&
		fg('add_nin_press_interactions')
	) {
		traceUFOPress('issue-navigator.filter');
	}
};
